var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "dialogDrag", rawName: "v-dialogDrag" }],
          attrs: {
            title: _vm.title,
            "close-on-click-modal": false,
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "inputForm",
              class: _vm.method === "view" ? "readonly" : "",
              attrs: {
                model: _vm.inputForm,
                size: "small",
                disabled: _vm.method === "view",
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "国名", prop: "name", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写国名" },
                            model: {
                              value: _vm.inputForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "name", $$v)
                              },
                              expression: "inputForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "人口", prop: "sum", rules: [] } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请填写人口" },
                            model: {
                              value: _vm.inputForm.sum,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "sum", $$v)
                              },
                              expression: "inputForm.sum",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "所属洲",
                            prop: "continent.id",
                            rules: [],
                          },
                        },
                        [
                          _c("GridSelect", {
                            attrs: {
                              title: "选择所属洲",
                              labelName: "name",
                              labelValue: "id",
                              value: _vm.inputForm.continent.id,
                              limit: 1,
                              columns: [
                                {
                                  prop: "name",
                                  label: "洲名",
                                },
                              ],
                              searchs: [
                                {
                                  prop: "name",
                                  label: "洲名",
                                },
                              ],
                              dataListUrl: "/test/grid/testContinent/list",
                              queryEntityUrl:
                                "/test/grid/testContinent/queryById",
                            },
                            on: {
                              getValue: function (value) {
                                _vm.inputForm.continent.id = value
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "备注信息",
                            prop: "remarks",
                            rules: [],
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              type: "textarea",
                              placeholder: "请填写备注信息",
                            },
                            model: {
                              value: _vm.inputForm.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.inputForm, "remarks", $$v)
                              },
                              expression: "inputForm.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
              _vm.method != "view"
                ? _c(
                    "el-button",
                    {
                      directives: [
                        { name: "noMoreClick", rawName: "v-noMoreClick" },
                      ],
                      attrs: { size: "small", type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.doSubmit()
                        },
                      },
                    },
                    [_vm._v("确定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }